/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Form from './Form/index'
import Matches from './Matches/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/NewPatient/Content"
  
}) {
  return (<React.Fragment
>
<Form
  viewPath={`${viewPath}/Form`}
/>
<Matches
  viewPath={`${viewPath}/Matches`}
/>
{children}
</React.Fragment>)
}